export interface AdminAuditLogFilters {
  tenantName: string;
}

export const defaultFilters: AdminAuditLogFilters = {
  tenantName: '',
};
